import { render, staticRenderFns } from "./FooterLogoForm.vue?vue&type=template&id=7d93e169&"
import script from "./FooterLogoForm.vue?vue&type=script&lang=js&"
export * from "./FooterLogoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports